import { useState } from "react";
import InputField from "../../applicationUi/components/intake/InputField";
import CheckboxField from "../../applicationUi/components/intake/CheckboxField";
import TextAreaField from "../../applicationUi/components/intake/TextAreaField";

const ParentGuardianSection = ({
  formData,
  handleChange,
  isReadOnly = false,
}) => {
  const [showParent2, setShowParent2] = useState(false); // State to show/hide Parent 2

  const toggleParent2 = () => setShowParent2(!showParent2);

  return (
    <section className="space-y-8">
      <div className="space-y-2">
        <h2 className="text-xl font-semibold text-foreground">
          Parent/Guardian Information
        </h2>
        <p className="text-sm text-muted-foreground">
          Please provide contact information for the primary caregivers.
        </p>
      </div>

      {/* Parent 1 Fields */}
      <div className="space-y-4">
        <h3 className="text-lg font-semibold text-foreground border-b border-border pb-2">
          Primary Parent/Guardian
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <InputField
            label="First Name"
            name="parentGuardian1.firstName"
            value={formData.parentGuardian1.firstName}
            onChange={handleChange}
            readOnly={isReadOnly}
          />
          <InputField
            label="Last Name"
            name="parentGuardian1.surname"
            value={formData.parentGuardian1.surname}
            onChange={handleChange}
            readOnly={isReadOnly}
          />
          <InputField
            label="Relationship to Client"
            name="parentGuardian1.relationshipToClient"
            value={formData.parentGuardian1.relationshipToClient}
            onChange={handleChange}
            readOnly={isReadOnly}
          />
          <InputField
            label="Email"
            name="parentGuardian1.email"
            value={formData.parentGuardian1.email}
            onChange={handleChange}
            readOnly={isReadOnly}
          />
          <InputField
            label="Cell Phone"
            name="parentGuardian1.cellPhone"
            value={formData.parentGuardian1.cellPhone}
            onChange={handleChange}
            readOnly={isReadOnly}
          />
          <InputField
            label="Home Phone"
            name="parentGuardian1.homePhone"
            value={formData.parentGuardian1.homePhone}
            onChange={handleChange}
            readOnly={isReadOnly}
          />
          <InputField
            label="Work Phone"
            name="parentGuardian1.workPhone"
            value={formData.parentGuardian1.workPhone}
            onChange={handleChange}
            readOnly={isReadOnly}
          />
          <InputField
            label="Occupation"
            name="parentGuardian1.occupation"
            value={formData.parentGuardian1.occupation}
            onChange={handleChange}
            readOnly={isReadOnly}
          />
          <CheckboxField
            label="Main Contact"
            name="parentGuardian1.mainContact"
            checked={formData.parentGuardian1.mainContact}
            onChange={handleChange}
            readOnly={isReadOnly}
          />
        </div>

        {/* Full width Notes field for Parent 1 */}
        <TextAreaField
          label="Notes"
          name="parentGuardian1.notes"
          value={formData.parentGuardian1.notes}
          onChange={handleChange}
          readOnly={isReadOnly}
        />
      </div>

      {/* Toggle button for Parent 2 */}
      <button
        type="button"
        onClick={toggleParent2}
        className="inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground h-9 px-4 py-2">
        {showParent2
          ? "- Hide Secondary Parent/Guardian"
          : "+ Add Secondary Parent/Guardian"}
      </button>

      {showParent2 && (
        <div className="space-y-4">
          {/* Parent 2 Fields */}
          <h3 className="text-lg font-semibold text-foreground border-b border-border pb-2">
            Secondary Parent/Guardian
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <InputField
              label="First Name"
              name="parentGuardian2.firstName"
              value={formData.parentGuardian2.firstName}
              onChange={handleChange}
              readOnly={isReadOnly}
            />
            <InputField
              label="Last Name"
              name="parentGuardian2.surname"
              value={formData.parentGuardian2.surname}
              onChange={handleChange}
              readOnly={isReadOnly}
            />
            <InputField
              label="Relationship to Client"
              name="parentGuardian2.relationshipToClient"
              value={formData.parentGuardian2.relationshipToClient}
              onChange={handleChange}
              readOnly={isReadOnly}
            />
            <InputField
              label="Email"
              name="parentGuardian2.email"
              value={formData.parentGuardian2.email}
              onChange={handleChange}
              readOnly={isReadOnly}
            />
            <InputField
              label="Cell Phone"
              name="parentGuardian2.cellPhone"
              value={formData.parentGuardian2.cellPhone}
              onChange={handleChange}
              readOnly={isReadOnly}
            />
            <InputField
              label="Home Phone"
              name="parentGuardian2.homePhone"
              value={formData.parentGuardian2.homePhone}
              onChange={handleChange}
              readOnly={isReadOnly}
            />
            <InputField
              label="Work Phone"
              name="parentGuardian2.workPhone"
              value={formData.parentGuardian2.workPhone}
              onChange={handleChange}
              readOnly={isReadOnly}
            />
            <InputField
              label="Occupation"
              name="parentGuardian2.occupation"
              value={formData.parentGuardian2.occupation}
              onChange={handleChange}
              readOnly={isReadOnly}
            />
            <CheckboxField
              label="Main Contact"
              name="parentGuardian2.mainContact"
              checked={formData.parentGuardian2.mainContact}
              onChange={handleChange}
              readOnly={isReadOnly}
            />
          </div>

          {/* Full width Notes field for Parent 2 */}
          <TextAreaField
            label="Notes"
            name="parentGuardian2.notes"
            value={formData.parentGuardian2.notes}
            onChange={handleChange}
            readOnly={isReadOnly}
          />
        </div>
      )}
    </section>
  );
};

export default ParentGuardianSection;
